var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"engroup"},[_c('span',{staticClass:"caption"},[_vm._v("x "+_vm._s(_vm.label)+" x")])])
}
var staticRenderFns = []

export { render, staticRenderFns }